export default __webpack_public_path__ + "static/media/climber_icon_contact.c7a61414.svg";